import TeachersGridTest from './TeachersGridTest';

export default TeachersGridTest;